import { CcfCallResloveIcon, CcfCallMergeIcon } from '@nice-ccf/ui-controls';
import { CallIcons, ccfCallActions } from '../ccf-call-conference.slice';

export const callConferenceHoldIcons: CallIcons[] = [
  {
    type: 'action',
    icon: <CcfCallMergeIcon fontSize="small" />,
    dispatcherAction: ccfCallActions.addUserToConference,
  },
  // {
  //   type: 'action',
  //   icon: <CcfCallResloveIcon/>,
  //   dispatcherAction: ccfCallActions.resetState
  // }
];
